export const log = (tag) => (...args) => {
    console.log(tag, ...args)
    return args.length === 1 ? args[0] : args
}